import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppConfigService } from '@app_services/appconfigservice';
import { AuthService } from '@app_services/auth.service';
import { map } from 'rxjs';

// export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
//   const router = inject(Router);
//   const authService = inject(AuthService);

//   if (authService.isLoggedIn()) {
//     return true;
//   }

//   return router.createUrlTree(['/login'], {
//     queryParams: { returnUrl: state.url },
//   });

//   // return true;
// };

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  return authService.isLoggedIn().pipe(
    map(isLoggedIn => {
      if (isLoggedIn) {
        return true;
      } else {
        return router.createUrlTree(['/login'], {
          queryParams: { returnUrl: state.url },
        });
      }
    }),
  );
};

export const isCustomerGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.hasCustomerRights()) {
    return true;
  }

  return router.createUrlTree(['/not-authorized'], {
    queryParams: {
      page: state.url,
      // access: 'admin'
    },
  });

  // return true;
};

export const isEnvironmentGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.hasEnvironmentRights()) {
    return true;
  }

  return router.createUrlTree(['/not-authorized'], {
    queryParams: {
      page: state.url,
      // access: 'admin'
    },
  });

  // return true;
};

export const isAdminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.hasAdminRights()) {
    return true;
  }

  return router.createUrlTree(['/not-authorized'], {
    queryParams: {
      page: state.url,
      // access: 'admin'
    },
  });

  // return true;
};

export const isResellerGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (authService.hasResellerRights()) {
    return true;
  }

  return router.createUrlTree(['/not-authorized'], {
    queryParams: {
      page: state.url,
      // access: 'reseller'
    },
  });

  // return true;
};

export const isResellerFttbOrderingEnabledGuard: CanActivateFn = (
  route,
  state,
) => {
  const router = inject(Router);
  const appConfigService = inject(AppConfigService);

  if (appConfigService.resellerFttbOrderingEnabled) {
    return true;
  }

  return router.createUrlTree(['/not-authorized'], {
    queryParams: {
      page: state.url,
    },
  });
};
